import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Icon from '../../../../../../modules/react/components/stateless/Icon';
import useCurrentPage from '../../../../../hooks/useCurrentPage';
import styles from './ActionArrow.scss';

const propTypes = {
  toggleModal: PropTypes.func.isRequired,
  isUnitGroupExpanded: PropTypes.bool.isRequired,
  toggleTiers: PropTypes.func.isRequired,
  enableTieredPricing: PropTypes.bool.isRequired,
};

const ActionArrow = ({ toggleModal, enableTieredPricing, isUnitGroupExpanded, toggleTiers }) => {
  const { secondaryColorClass } = useCurrentPage();
  let iconId = 'select-arrow';
  if (enableTieredPricing) {
    iconId = isUnitGroupExpanded ? 'collapse' : 'expand';
  }
  const handleActionArrowClick = () => {
    if (enableTieredPricing) {
      toggleTiers('actionArrow');
    } else {
      toggleModal();
    }
  };
  return (
    <Button
      className={`d-sm-block d-md-block d-lg-none ${styles.mobileCaret}`}
      variant="link"
      block
      data-testid="actions-button"
      onClick={handleActionArrowClick}
    >
      <Icon
        className={secondaryColorClass}
        id={iconId}
        onClick={handleActionArrowClick}
        label="Show"
      />
    </Button>
  );
};

ActionArrow.propTypes = propTypes;

export default ActionArrow;
